/**
 * §P.1 · La importación del Excel.
 *
 * Va en **dos pasos que no se pueden unir**, y el motivo está en `BFF_BO.md` §7.1:
 *
 * > **Nunca importéis a ciegas.** El Excel real de un club tiene fechas en tres
 * > formatos, dos columnas de teléfono y filas en blanco. La pantalla de
 * > previsualización —«430 filas correctas, 12 con problemas, aquí están»— es el
 * > primer contacto del cliente con el producto, y es la diferencia entre
 * > confianza y un desastre el primer día.
 */

export interface ProblemaDeFila {
  readonly field: string;
  readonly message: string;
}

export interface FilaImportada {
  /** La fila **del fichero**, contando la cabecera: lo que la persona ve en Excel. */
  readonly number: number;
  readonly data: {
    readonly first_name: string | null;
    readonly last_name: string | null;
    readonly birth_date: string | null;
    readonly student_code: string | null;
    readonly group_name: string | null;
    readonly rank_name: string | null;
    readonly guardian_name: string | null;
    readonly guardian_email: string | null;
  };
  /** Impiden importar la fila. Con uno solo, `will_import` es `false`. */
  readonly errors: readonly ProblemaDeFila[];
  /** No impiden nada: la fila entra, pero con algo menos. */
  readonly warnings: readonly ProblemaDeFila[];
  readonly will_import: boolean;
}

export interface Previsualizacion {
  readonly id: string;
  readonly filename: string | null;
  /** `previewed`, `committed` o `expired`. */
  readonly status: string;
  readonly total_rows: number;
  readonly valid_rows: number;
  readonly imported_rows: number | null;
  readonly rows: readonly FilaImportada[];
  readonly expires_at: Date | string | null;
}

export const nombreDeFila = (f: FilaImportada): string =>
  [f.data.first_name, f.data.last_name].filter(Boolean).join(' ') ||
  '(sin nombre)';

/** Las que traen algo que mirar, que son las que hay que enseñar primero. */
export const conProblemas = (
  filas: readonly FilaImportada[]
): readonly FilaImportada[] =>
  filas.filter((f) => f.errors.length > 0 || f.warnings.length > 0);
